<template>
  <component :is="planComponent" v-if="modelTypeResolved"/>
</template>

<script>
import ModelB from '@/views/SmartLogistics/ModelB.vue'
import ModelC from '@/views/SmartLogistics/ModelC.vue'
import { mapActions, mapGetters } from 'vuex'
import router from '@/router'
import {ModelViewMixin} from "@/mixins/SmartLogistics/ModelView";

export default {
  name: 'SmartLogistics',
  components: { ModelC, ModelB },
  mixins: [ModelViewMixin],

  data () {
    return {
      modelTypeResolved: false
    }
  },

  computed: {
    ...mapGetters({
      planModel: 'smartLogisticSettings/planModel',
      selectedDate: 'smartLogisticSettings/selectedDate',
    }),

    planComponent () {
      if (this.planModel === 'c') {
        return ModelC
      } else {
        return ModelB
      }
    }
  },

  beforeCreate () {
    if (!this.selectedDate) {
      // ensure that selectedDate is set
      this.$store.commit('smartLogisticSettings/setSelectedDate', this.$moment().startOf('month'))
    }
  },
}
</script>


<style lang="scss">
@import "./src/scss/smartlogistics/smartlogistics.scss";

.v-expansion-panel-content__wrap {
  &:last-child {
    margin-bottom: 20px;
  }
}
</style>
